import { render, staticRenderFns } from "./club-register.vue?vue&type=template&id=3ebc1321&"
import script from "./club-register.vue?vue&type=script&lang=js&"
export * from "./club-register.vue?vue&type=script&lang=js&"
import style0 from "./club-register.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Vuejs-Project\\subsappadminOrg\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ebc1321')) {
      api.createRecord('3ebc1321', component.options)
    } else {
      api.reload('3ebc1321', component.options)
    }
    module.hot.accept("./club-register.vue?vue&type=template&id=3ebc1321&", function () {
      api.rerender('3ebc1321', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/registration/club-register.vue"
export default component.exports